import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import LipaLater from "../assets/img/lipalater.png";
import Ecobank from "../assets/img/ecobank.png";
import Dash from "../assets/img/dash.png";
import HustleSasa from "../assets/img/hustlesasa.png";
import Ntl from "../assets/img/ntl.png";
import Agrikore from "../assets/img/agrikore.png";

// Configuration for related projects
const relatedProjects = {
  'dash': [
    { link: '/portfolio/lipa-later', image: LipaLater, alt: 'Lipa Later Project' },
    { image: Ntl, alt: 'NTL Project' }
  ],
  'lipa-later': [
    { image: Ecobank, alt: 'Ecobank Project' },
    { link: '/portfolio/hustle-sasa', image: HustleSasa, alt: 'Hustle Sasa Project' }
  ],
  'hustle-sasa': [
    { link: '/portfolio/dash', image: Dash, alt: 'Dash Project' },
    { link: '/portfolio/agrikore', image: Agrikore, alt: 'Agrikore Project' }
  ],
  'agrikore': [
    { image: Ecobank, alt: 'Ecobank Project' },
    { image: Ntl, alt: 'NTL Project' }
  ]
};


function MoreProjects(props) {
  const projects = relatedProjects[props.selectedPortfolio] || [];

  return (
    <section>
        <div className="container more-projects-padd">
            <h3>OTHER PROJECTS</h3>

            <div className="row mt-5" data-aos="fade-up" data-aos-once="true" data-aos-easing="ease-out-cubic" data-aos-duration="800">
                {projects.map((project, index) => (
                  <div className="col-12 col-md-6 mt-4" key={`related-project-${index}`}>
                    {project.link ? (
                      <Link to={project.link}>
                        <img src={project.image} alt={project.alt} />
                      </Link>
                    ) : (
                      <img src={project.image} alt={project.alt} />
                    )}
                  </div>
                ))}
            </div>
        </div>
    </section>
  )
}

MoreProjects.propTypes = {
  selectedPortfolio: PropTypes.string.isRequired
};

export default MoreProjects;
